
import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../../../commons";

type AppProps = {
  data: any;
  header: TableHeadersType[];
  handleEditHiringCheckList?:(data:any)=>void;
};
const StickyHiringTableData = ({
  data,
  header,
  handleEditHiringCheckList

}: AppProps) => {
  
  return (
    data?.length > 0 &&
    data?.map((dataItem: any) => {
      return (
        <tr>
          {header?.map((headerData: TableHeadersType) => {
          
             if (headerData?.value === "name") {
                return (
                  <td 
                  style={{minWidth:'200px', whiteSpace:'nowrap'}}

                  >
                    <div
                      className="ml-2"
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "start",
                        gap: "7px",
                        minWidth: "180px",
                        
                      }}
                      onClick={() => handleEditHiringCheckList?.(dataItem)}
                    >
                      <div>
                        <CircularAvatar
                          name={`${dataItem?.name}`}
                          image={
                            dataItem?.profile_pic &&
                            dataItem?.profile_pic?.file_url
                          }
                        />
                      </div>
                      <div>
                        <span style={{ textDecoration: "underline",
                          fontWeight: "600",
                          cursor: "pointer",}}>{dataItem?.name}</span>
                        <p style={{fontSize:'12px',color:'#6e7491',margin:'0px'}}>{dataItem?.email}</p>
                        <p style={{fontSize:'12px',color:'#6e7491',margin:'0px'}}>{dataItem?.phone_number}</p>
  
  
                      </div>
                    </div>
                  </td>
                );
              }
          })}
        </tr>
      );
    })
  );
};

export default StickyHiringTableData;

